import { BodyText, Icon, BodyTextProps } from '@servicetitan/design-system';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { FC } from 'react';

export const LocationBodyText: FC<BodyTextProps> = observer(props => {
    const { children, className, location, ...otherProps } = props;
    return (
        <BodyText
            subdued
            size="small"
            className={classNames('t-truncate', className)}
            {...otherProps}
        >
            <Icon name="place" size={16} className="m-r-half m-b-half" />
            {children}
        </BodyText>
    );
});
